const escapeRegExp = (str: string) => {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
};

export const replaceAll = (str: string, find: string, replace: string) => {
    return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
};

export const getImageDimensions = (file: any) => {
    return new Promise(function (resolved) {
        var i = new Image()
        i.onload = function () {
            resolved({ w: i.width, h: i.height })
        };
        i.src = file
    })
}

export const getValFromPath = (project: any, path: string) => {
    return path.split(".").reduce((res, prop) => res[prop], project);
};

export const jsonParse = (_string: any) => {
    try {
        return JSON.parse(_string)
    } catch (err) {
        return false
    }
}